import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

const EditableText = ({ tooltip, editable, content, handleOnBlur }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
  };
  return (
    <Tooltip title={tooltip} placement="top">
      <span
        contentEditable={editable}
        style={{
          backgroundColor: editable ? "yellow" : "transparent",
        }}
        onBlur={handleOnBlur}
        onKeyDown={handleKeyDown}
      >
        {content}
      </span>
    </Tooltip>
  );
};

EditableText.propTypes = {
  tooltip: PropTypes.string,
  editable: PropTypes.bool,
  content: PropTypes.string,
  handleOnBlur: PropTypes.func,
};

export default EditableText;
